module.exports = __webpack_public_path__ + "static/truckslider-04-min-d9399c5d243d2677cc606a02f7cf0e5e.jpg";